(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-sun-discovery-rail]').forEach((rail) => {
      if (rail.dataset.discoveryReady) return;
      const track = rail.querySelector('[data-sun-discovery-track]');
      const controls = rail.querySelector('[data-sun-discovery-controls]');
      const previous = rail.querySelector('[data-sun-discovery-prev]');
      const next = rail.querySelector('[data-sun-discovery-next]');
      if (!track || !controls || !previous || !next) return;
      rail.dataset.discoveryReady = 'true';

      const update = () => {
        const maximum = track.scrollWidth - track.clientWidth;
        controls.hidden = maximum <= 2;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
      };
      const move = (direction) => {
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        track.scrollBy({ left: direction * (track.clientWidth + gap), behavior });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', (event) => {
        // Links retain their ordinary keyboard behavior; the track itself supports arrows.
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(update);
        observer.observe(track);
        // Clean up when Shopify replaces a section in the theme editor.
        const onUnload = (event) => {
          if (!event.target.contains(rail)) return;
          observer.disconnect();
          document.removeEventListener('shopify:section:unload', onUnload);
        };
        document.addEventListener('shopify:section:unload', onUnload);
      } else {
        window.addEventListener('resize', update);
      }
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
